import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllVolumeDiscounts extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VolumeDiscounts/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateANewVolumeDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VolumeDiscounts/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateAVolumeDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VolumeDiscounts/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAVolumeDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VolumeDiscounts/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  GetAllVolumeDiscounts,
  CreateANewVolumeDiscount,
  UpdateAVolumeDiscount,
  DeleteAVolumeDiscount,
};
